import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import themeStyles from '../styles/Card.styles';
const ImageNotFoundWrapper = themeStyles.apply(Box, 'ImageNotFoundWrapper');
const ImageNotFoundCopy = themeStyles.apply(Copy, 'ImageNotFoundCopy');
const ImageNotFound = ({ altTextContent = 'Image coming soon', key }) => (_jsx(ImageNotFoundWrapper, { children: _jsx(ImageNotFoundCopy, { "data-testid": "cy-no-model-image", children: altTextContent }) }, key));
export default ImageNotFound;
